/**
 * ServiceOrderModalTabs - Barra de abas (36px) do modal de detalhes da OS.
 *
 * Mesmas classes do TaskModalTabs (fundo muted, texto primário na ativa,
 * contador arredondado e indicador inferior).
 *
 * RELEASE: 2026-10-16 v1.3.0 - Logística Fase 4: aba Remessas.
 * RELEASE: 2026-10-09 v1.2.0 - BR-OS-026: aba Chat e prop `hiddenTabs`.
 * RELEASE: 2026-10-09 v1.1.0 - Inclui histórico dedicado de Pausas.
 * RELEASE: 2026-10-09 v1.0.0 - Versão inicial (padronização com Tarefas).
 */
import { CalendarClock, ClipboardCheck, ClipboardList, History, LayoutDashboard, MessageCircle, MessageSquare, Package, Pause, Truck } from 'lucide-react';
import { ModalSubTabs } from '@/components/shared/details-modal/ModalSubTabs';

// RELEASE: 2026-10-17 v1.4.0 - Aba Itens (serviços do negócio).
export type ServiceOrderModalTab = 'activity' | 'summary' | 'items' | 'checklists' | 'products' | 'schedule' | 'chat' | 'pauses' | 'history' | 'shipments';

/** Ordem oficial das abas; Andamentos é sempre a primeira experiência da ficha. */
export const SERVICE_ORDER_MODAL_TABS: { id: ServiceOrderModalTab; label: string; icon: typeof History }[] = [
  { id: 'activity', label: 'Andamentos', icon: MessageSquare },
  { id: 'summary', label: 'Resumo', icon: LayoutDashboard },
  { id: 'items', label: 'Itens', icon: ClipboardList },
  { id: 'checklists', label: 'Checklists', icon: ClipboardCheck },
  { id: 'products', label: 'Movimentações', icon: Package },
  { id: 'shipments', label: 'Remessas', icon: Truck },
  { id: 'schedule', label: 'Agenda', icon: CalendarClock },
  { id: 'chat', label: 'Chat', icon: MessageCircle },
  { id: 'pauses', label: 'Pausas', icon: Pause },
  { id: 'history', label: 'Histórico', icon: History },
];

interface Props {
  activeTab: ServiceOrderModalTab;
  onTabChange: (tab: ServiceOrderModalTab) => void;
  /** Contadores opcionais por aba */
  counts?: Partial<Record<ServiceOrderModalTab, number>>;
  /** Abas ocultas (ex.: Chat quando o cliente não tem contato principal) */
  hiddenTabs?: ServiceOrderModalTab[];
}

// RELEASE: 2026-10-18 v1.5.0 - Usa ModalSubTabs compartilhado (mesmo visual).
export function ServiceOrderModalTabs({ activeTab, onTabChange, counts = {}, hiddenTabs = [] }: Props) {
  return (
    <ModalSubTabs active={activeTab} onChange={onTabChange}
      items={SERVICE_ORDER_MODAL_TABS.filter((t) => !hiddenTabs.includes(t.id)).map(t => ({ ...t, count: counts[t.id] }))} />
  );
}
